import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { ModifySelectionBilan } from "@/modules/selection/ModifySelectionBilan";
import TabsFormChampVisuel from "@/components/practitioner/champVisuel/TabsFormChampVisuel";
import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import ModifySelectionZF from "@/modules/selection/ModifySelectionZF";
import { FormResultats } from "@/components/practitioner/champVisuel/FormResultats";

export interface Selection {
  id: string;
  timeline: string;
  patientId: string;
  selection: string;
  isDefault: boolean;
}

export interface SessionResults {
  id: number;
  sessionDate: string;
  resultsBilan: string;
  resultsZF: string;
  sujet: string;
  fiable: boolean;
  visualFieldInput: string;
  screenUsed : string;
  removedRows: number[];
  removedColumns: number[];
  order : number;
  sessionType : "BILAN" | "REEDUCATION";
  accountUsed : "CLINIQUE" | "PATIENT";
}

interface ModifySelectionBilanMethods {
  triggerAutoSelectCells: () => void;
  triggerDownloadModifiedData: () => void;
}

interface ModifySelectionZFMethods {
  triggerAutoSelectCells: () => void;
  triggerDownloadModifiedData: () => void;
}

const defaultSelection: Selection = {
  id: '',
  timeline: '',
  patientId: '',
  selection: '',
  isDefault: false,
};

export default function ChampVisuelParameter() {
  const [sessionResults, setSessionResults] = useState<SessionResults>();
  const [sessionsResults, setSessionsResults] = useState<SessionResults[]>([]);
  const [selections, setSelections] = useState<Selection[]>([]);
  const [selection, setSelection] = useState<Selection>(defaultSelection);
  const [mode] = useState("selection");
  const selectionRef = useRef<{ ZF: string[]; ZP: string[]; ZV: string[]; }>({
    ZF: [],
    ZP: [],
    ZV: []
});

  const { patientId } = useParams<{ patientId: string }>();

  const modifySelectionBilanRef = useRef<ModifySelectionBilanMethods | null>(
    null
  );

  const modifySelectionZFRef = useRef<ModifySelectionZFMethods | null>(null);

  useEffect(() => {
    const handleKeyPress = (event: { key: string }) => {
      if (event.key === "t") {
        updateSelectionBilan();
      }
    };

    window.addEventListener("keydown", handleKeyPress);

    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  });

  const autoSelectCellsBasedOnResultsZF = () => {
    if (modifySelectionZFRef.current) {
      modifySelectionZFRef.current.triggerAutoSelectCells();
    }
  };

  const updateSelectionZF = () => {
    if (modifySelectionZFRef.current) {
      modifySelectionZFRef.current.triggerDownloadModifiedData();
    }
  };

  const autoSelectCellsBasedOnResultsBilan = () => {
    if (modifySelectionBilanRef.current) {
      modifySelectionBilanRef.current.triggerAutoSelectCells();
    }
  };

  const updateSelectionBilan = () => {
    if (modifySelectionBilanRef.current) {
      modifySelectionBilanRef.current.triggerDownloadModifiedData();
    }
  };

  const updateSelection = () => {
    if (
      sessionResults &&
      sessionResults.resultsBilan !== null &&
      sessionResults.resultsBilan !== undefined &&
      sessionResults.resultsBilan !== "" &&
      sessionResults.resultsBilan !== "null"
    ) {
      return updateSelectionBilan();
    } else {
      return updateSelectionZF();
    }
  };

  const autoSelectCells = () => {
    if (
      sessionResults &&
      sessionResults.resultsBilan !== null &&
      sessionResults.resultsBilan !== undefined &&
      sessionResults.resultsBilan !== "" &&
      sessionResults.resultsBilan !== "null"
    ) {
      return autoSelectCellsBasedOnResultsBilan();
    } else {
      return autoSelectCellsBasedOnResultsZF();
    }
  };

  useEffect(() => {
    axios
      .get(`/practitioner/visualfield/${patientId}/result`)
      .then((response) => {
        setSessionsResults(response.data);
      })
      .catch((error) => {
        console.error("Erreur lors de la récupération des données:", error);
      });
    axios
      .get(`/practitioner/visualfield/${patientId}/selection`)
      .then((response) => {
        setSelections(response.data);
      })
      .catch((error) => {
        console.error("Erreur lors de la récupération des données:", error);
      });
  }, [patientId]);

  useEffect(() => {
  }, [sessionResults]);

  return (
    <Card className="w-5/6 h-5/6">
      <CardHeader className="flex flex-row">
        <div className="w-2/3 flex flex-col items-center space-y-6">
          <div>
            <CardTitle>Champ Visuel</CardTitle>
            <CardDescription>
              Paramétrage des zones de travail
            </CardDescription>
          </div>
          <div className="mt-4 border-black border-2 p-6 rounded-lg flex flex-col items-start">
            <p className="text-md font-bold text-gray-800 ">
              Résultats : {sessionResults?.sujet} -{" "}
              {sessionResults?.sessionDate ? new Date(sessionResults.sessionDate).toLocaleDateString("fr-FR") : "Date inconnue"} - {sessionResults?.screenUsed ? sessionResults.screenUsed : "Non renseigné"}
            </p>
            <p className="text-md text-gray-600 mt-1">
              Zone de travail : {selection ? selection?.timeline : "Aucune Sélection"}
            </p>
          </div>
        </div>
        <div className="w-1/3">
          <FormResultats
            setSessionResults={setSessionResults}
            sessionsResults={sessionsResults}
            autoSelectCells={autoSelectCells}
          />
        </div>
      </CardHeader>
      <CardContent className="flex flex-row">
        <div className="w-3/4 border-2">
          {sessionResults &&
          sessionResults.resultsBilan !== null &&
          sessionResults.resultsBilan !== undefined &&
          sessionResults.resultsBilan !== "" &&
          sessionResults.resultsBilan !== "null" ? (
            <ModifySelectionBilan
              ref={modifySelectionBilanRef}
              selectionData={selection ? { selection: selection.selection } : { selection: '' }}
              resultData={sessionResults}
              mode={mode}
              selectionRef={selectionRef}
            />
          ) : (
            <ModifySelectionZF
              ref={modifySelectionZFRef}
              selectionRef={selectionRef}
              selectionData={selection || { selection: "" }}
              resultData={sessionResults || { resultsZF: "", visualFieldInput: "", resultsBilan: "", screenUsed: "",  removedRows: [], removedColumns: [], sessionDate: "", sujet: "", fiable: false, id: 0, accountUsed: "CLINIQUE", sessionType: "BILAN", order: 0 }}
            />
          )}
        </div>
        <div className="w-1/4 border-2">
          <TabsFormChampVisuel
            patientId={patientId || ""}
            setSelections={setSelections}
            setSelection={setSelection}
            selections={selections}
            selection={selection || defaultSelection}
            selectionRef={selectionRef}
            updateSelection={updateSelection}
          />
        </div>
      </CardContent>
    </Card>
  );
}
